import { MaxBrainScheduledStreamContent } from './scheduled-stream-content.model';

export class ScheduledStreamContentCommand {
    constructor(tempTap: MaxBrainScheduledStreamContent) {}
}
